module.exports = __webpack_public_path__ + "img/img4.dc4e8b0d.png";